import type { NuxtApp } from '#app'
import { useNotificationsStore } from '~/stores/useNotificationsStore'
import { notificationsConnectionTracking } from '~/utils/notificationsConnectionTracking'

// Module-side so an identity change clears the inbox and drops the Echo connection with no component mounted.
export const resetAccountNotifications = (nuxtApp: NuxtApp): void => {
  notificationsConnectionTracking.invalidate()
  useNotificationsStore().reset()

  try {
    notificationsConnectionTracking.stop()
  } finally {
    nuxtApp.$notificationsEcho?.disconnect()
  }
}
